import { NOMINAS } from '../actions/types';

const initialState = {
    listado: [],
    detalles: null
};

export default (state = initialState, action) => {
    const { type, payload } = action;

    switch (type) {
        case NOMINAS.BUSCAR:
            return { ...state, listado: payload };

        case NOMINAS.DETALLES:
            return { ...state, detalles: payload };

        case NOMINAS.AGREGAR:
            return { ...state, listado: [payload, ...state.listado] };

        case NOMINAS.EDITAR:
            return {
                ...state,
                listado: state.listado.map(n => n._id === payload._id ? payload : n)
            };

        case NOMINAS.LIMPIAR:
            return { ...state, detalles: null };

        default:
            return state;
    }
};
